<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Confirm Refund'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row>
            <tidy-radio-button
              [label]="'Why are you requesting a refund?'"
              formControlName="reason"
              [form]="form.controls.reason"
              [items]="refundReasons"
              [submitted]="submitted"
              [errorMessage]="'Please select a reason.'" />
          </tidy-row>
        </form>
      </tidy-card>
      <tidy-button
        [action]="boundSubmit"
        [text]="'Submit'"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
